import { useEffect, useState } from "react";
import api from "../../services/api";
import Brackets from "./Brackets";
import { motion } from "framer-motion";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get("/categories");
        setCategories(res.data);
      } catch (err) {
        console.error("Failed to load categories", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  if (loading) {
    return <p className="text-center mt-10">Loading...</p>;
  }

  return (
    <div className="max-w-6xl mx-auto text-center px-4">
      
      {/* Stats Banner */}
      <div className="bg-gradient-to-r from-yellow-300 to-yellow-100 py-4 px-6 rounded-lg shadow-md mt-8 mb-10 flex flex-col sm:flex-row justify-between items-center gap-4">
        <p className="font-bold text-lg">📂 Total Categories: 6</p>
        <p className="text-gray-700">🔥 Ongoing Events:0</p>
        <p className="text-gray-700">🏆 Champions:0 </p>
      </div>

      {/* Categories Section */}
      <div className="mt-6">
        <h2 className="text-2xl font-bold mb-6">Categories</h2>
        {categories.length === 0 ? (
          <p className="text-gray-500">No categories available.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {categories.map((cat, idx) => (
              <motion.div
                key={cat.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.05 }}
                className="relative bg-white rounded-lg shadow hover:shadow-lg transition group overflow-hidden"
              >
                {cat.image && (
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="h-40 w-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                )}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-primary">{cat.name}</h3>
                  {cat.description && <p className="text-sm text-gray-500 mt-2">{cat.description}</p>}
                  {cat.type && (
                    <span className="absolute top-3 right-3 bg-yellow-400 text-white text-xs px-3 py-1 rounded-full">
                      {cat.type}
                    </span>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>

      {/* Event Brackets */}
      <div className="mt-16">
        <h2 className="text-2xl font-bold mb-4">Select an event below to see the ongoing activities</h2>
        <div className="bg-white rounded-lg shadow p-6">
          <Brackets />
        </div>
      </div>
    </div>
  );
}
